import {ProductGroup} from 'core/constants/productGroups';

import {DocumentReportType, ProductStatus} from '../core/dictionaries';

import {PackageTypes} from './gtins';

export interface ValidationStatus {
    markingCodeConfirmed: boolean;
    errors: {code: string; message: string}[];
    info: {
        productName: string;
        productTrademark: string;
        quantity: number | null;
        authenticStatus: number | null;
        reason: string | null;
        status: ProductStatus;
        storageLocationId: number | null;
        nameStorageLocation: string | null;
        manufacturingDate: string;
        expirationDate: string;
        identityCode: string;
        gtin: string;
        countryManufacture: string;
        legalName: string;
        volume: number | null;
        alcohol: number | null;
        nicotine: number | null;
        tarContent: number | null;
        substance: string | null;
        releaseForm: string | null;
        packagingType: PackageTypes;
        storageConditions: string | null;
        weight: number | null;
    };
}

export enum ValidatedProductsGridAccessors {
    name = 'productName',
    code = 'identityCode',
    status = 'status',
    packageType = 'packagingType',
}

export interface CodeResponseTypeInfo {
    childrenMarkingCodes: CodeResponseTypeInfo[];
    gtin: string;
    hsnCode: string;
    hsnDescription: string;
    identityCode: string;
    packagingType: PackageTypes;
    productName: string;
    status: ProductStatus;
    productGroupCode: string;
    productTrademark: string;
}

export interface CodeResponseType {
    errors: {code: string; message: string}[];
    isValid: boolean;
    info: {
        childrenMarkingCodes: CodeResponseTypeInfo[];
        gtin: string;
        hsnCode: string;
        hsnDescription: string;
        identityCode: string;
        packagingType: PackageTypes;
        productName: string;
        status: ProductStatus;
        productGroupCode?: ProductGroup;
        productCode?: string;
        productRecall?: boolean;
        batchNumber?: string | null;
        manufacturingDate?: string | null;
        expirationDate?: string | null;
        nameStorageLocation?: string | null;
    };
}

export type CodeRequestType = Partial<{
    type: DocumentReportType;
    markingCode: string;
    aggregatorMarkingCode: string;
    storageLocationId: string;
    manufacturingDate: string;
    applicationDate: string;
    startCirculationDate: string;
    dropoutReason: string;
    salesChannel: string;
    scannedCodes: string[];
    batchNumber: string;
}>;
